import React, { FC, MouseEvent } from 'react';
import { Icon, Text } from '@cubeyou-team/hx-react-components';
import styled from 'styled-components';

import { DestinationItem } from 'src/modules/audience-activation/types';
import translations from 'src/lang';
import { DestinationCard } from './DestinationCard';

const lang = 'en-US';

interface DestinationsListProps {
  destinations: Array<DestinationItem>;
  onClick: (name: string) => void;
}

const EmptyDestinationsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1.25rem;
  padding: 2rem;
`;

const DestinationCards = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  justify-content: flex-start;
  gap: 0.625rem;

  &.hidden {
    visibility: hidden;
  }
`;

export const DestinationsList: FC<DestinationsListProps> = ({
  destinations,
  onClick,
}) => {
  if (destinations.length === 0) {
    return (
      <EmptyDestinationsList>
        <Icon icon="search" variant="secondary" size="xlarge" />
        <Text size="medium">
          {
            translations[lang].MODALS.AUDIENCE_ACTIVATION
              .DESTINATIONS_SEARCH_EMPTY_MESSAGE
          }
        </Text>
      </EmptyDestinationsList>
    );
  }

  return (
    <DestinationCards>
      {destinations.map(({ destination, image, isSelected }) => (
        <DestinationCard
          key={destination}
          title={destination}
          image={image}
          isSelected={isSelected}
          onClick={(e: MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            onClick(destination);
          }}
        />
      ))}
    </DestinationCards>
  );
};
